'use strict';

/**
 * @generated SignedSource<<0e4ab73096246cc41553849fc9013340>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "site"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "variation"
        }
    ], v1 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "iconName",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "label",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
        }
    ], v2 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                },
                {
                    "kind": "Variable",
                    "name": "site",
                    "variableName": "site"
                },
                {
                    "kind": "Variable",
                    "name": "variation",
                    "variableName": "variation"
                }
            ],
            "concreteType": "HeaderContent",
            "kind": "LinkedField",
            "name": "headerContent",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Category",
                    "kind": "LinkedField",
                    "name": "personalCategories",
                    "plural": true,
                    "selections": (v1 /*: any*/),
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Category",
                    "kind": "LinkedField",
                    "name": "businessCategories",
                    "plural": true,
                    "selections": (v1 /*: any*/),
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Category",
                    "kind": "LinkedField",
                    "name": "personalCategoriesDesktop",
                    "plural": true,
                    "selections": (v1 /*: any*/),
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Category",
                    "kind": "LinkedField",
                    "name": "businessCategoriesDesktop",
                    "plural": true,
                    "selections": (v1 /*: any*/),
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "HeaderSpaContentQuery",
            "selections": (v2 /*: any*/),
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "HeaderSpaContentQuery",
            "selections": (v2 /*: any*/)
        },
        "params": {
            "cacheID": "a10ac6f6cd58a340badb019063db93c2",
            "id": null,
            "metadata": {},
            "name": "HeaderSpaContentQuery",
            "operationKind": "query",
            "text": "query HeaderSpaContentQuery(\n  $id: String!\n  $site: String\n  $variation: String\n) {\n  headerContent(id: $id, site: $site, variation: $variation) {\n    personalCategories {\n      iconName\n      label\n      url\n    }\n    businessCategories {\n      iconName\n      label\n      url\n    }\n    personalCategoriesDesktop {\n      iconName\n      label\n      url\n    }\n    businessCategoriesDesktop {\n      iconName\n      label\n      url\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "5bbfa3c794ac77aac52776581431baff";

module.exports = node;
